module.exports = __webpack_public_path__ + "img/official-qrcode.ee39f3ad.jpg";